<template>
  <v-container class="base-form-new-barrier mx-2" fluid>
    <div class="base-form-new-barrier__header">
      <v-icon color="primary" class="base-form-new-barrier__header-icon">
        {{ typeBarrier === 'G' ? 'mdi-gate' : 'mdi-gate-arrow-right' }}
      </v-icon>
      <h1 class="base-form-new-barrier__title">{{ textTitle }}</h1>
    </div>
    <v-card class="base-form-new-barrier__type-card" flat outlined>
      <v-card-text class="pa-4">
        <v-autocomplete
          v-model="typeBarrier"
          label="Тип проезда"
          :items="typeBarriers"
          item-text="name"
          item-value="value"
          prepend-inner-icon="mdi-format-list-bulleted-type"
          outlined
          dense
          flat
          hide-details
          class="base-form-new-barrier__field"
        />
      </v-card-text>
    </v-card>
    <NewBarrier :type-barrier="typeBarrier" class="base-form-new-barrier__form mt-4" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import NewBarrier from './components/NewBarrier';
import { typeBarriers } from '../consts';

export default {
  name: 'BaseFormNewBarrier',
  components: { NewBarrier },
  data () {
    return {
      valid: true,
      value: '',
      typeBarrier: 'B',
      typeBarriers,
    };
  },
  computed: {
    textTitle () {
      if (this.typeBarrier === 'B') return 'Новый шлагбаум';
      if (this.typeBarrier === 'G') return 'Новые ворота';
      return '';
    },
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      loadManagementCompanies: 'ManagementCompany/getManagementCompanies',
    }),
  },
  created () {
    this.loadManagementCompanies();
  },
};
</script>

<style lang="scss" scoped>
.base-form-new-barrier__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.base-form-new-barrier__header-icon {
  flex-shrink: 0;
}

.base-form-new-barrier__title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.base-form-new-barrier__type-card {
  border-radius: 12px;
  max-width: 320px;
}

.base-form-new-barrier__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

@media screen and (max-width: 600px) {
  .base-form-new-barrier__type-card {
    max-width: 100%;
  }
}
</style>
